import type { Currency, ProductStockStatus, ProductType, ProductCategory } from '../../constants';

/**
 * Represents a top ranked product in a specific category
 */
export type TopRankedProduct = {
  productId: number;
  sku: string;
  name: string;
  brand: string;
  productLink: string;
  productImageUrls: string[];
  category: ProductCategory[];
  modifiedAt: string;
  currency: Currency;
  rating?: number;
  reviewCount?: number;
  status: ProductStockStatus;
  type: ProductType;
  originalPrice: number;
  salePrice: number;
  rank: number;
  discountPercentage?: number;
};
